import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/dashboard/store/selectors/dashboard';

export const categoriesSelector = createSelector(dashboardSelector, (state) => state.categories);
